import React, { useEffect } from 'react'
import { useIntl, IntlContextConsumer, changeLocale } from 'gatsby-plugin-intl'
import { useCookies } from 'react-cookie'
import Logo from 'assets/svgs/logo.svg'
import * as S from './Navbar.styles'

const languageCurrent = {
  pt: 'PT',
  en: 'EN',
}

const Navbar = () => {
  const { formatMessage, locale } = useIntl()
  const [, setCookie] = useCookies(['language'])

  useEffect(() => {
    setCookie('language', locale, {
      path: '/',
    })
  }, [])

  return (
    <S.Wrapper>
      <S.Container>
        <S.LogoWrapper href="#">
          <Logo aria-label="Vale" />
        </S.LogoWrapper>
        <S.MenuNav>
          <S.MenuLink to="#about">
            {formatMessage({ id: 'navbar.meeting' })}
          </S.MenuLink>
          <S.MenuLink to="#program">
            {formatMessage({ id: 'navbar.schedule' })}
          </S.MenuLink>
          <S.MenuLink to="#projects">
            {formatMessage({ id: 'navbar.projects' })}
          </S.MenuLink>
        </S.MenuNav>
        <S.LanguageWrapper>
          <IntlContextConsumer>
            {({ languages, language: currentLanguage }) =>
              languages.map((language) => (
                <S.LanguageButton
                  key={language}
                  active={currentLanguage === language}
                  onClick={() => {
                    setCookie('language', language, {
                      path: '/',
                    })
                    changeLocale(language)
                  }}
                >
                  {languageCurrent[language]}
                </S.LanguageButton>
              ))
            }
          </IntlContextConsumer>
        </S.LanguageWrapper>
        <S.Button>
          <S.Link href={`https://plataforma.vpsvale.com/`} />
          {formatMessage({ id: 'navbar.button' })}
        </S.Button>
      </S.Container>
    </S.Wrapper>
  )
}

export default Navbar
